// Is a given value a DOM element?
export default function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isElement.js
// module id = tZQJ
// module chunks = 0